export default __webpack_public_path__ + "static/media/disabled-quiz-icon.8492f3a6.svg";